import { useEffect, useState } from "react"
import type { Dispatch, SetStateAction } from "react"

const STORAGE_PREFIX = "___"
const isBrowser = typeof window !== "undefined"

/**
 * State synced to localStorage under a `___`-prefixed key.
 * Ported from lpr-web's `useStorage` (JSON-serialized values).
 */
export function useLocalStorage<T>(key: string, fallback: T): [T, Dispatch<SetStateAction<T>>] {
  const [value, setValue] = useState<T>(() => {
    if (!isBrowser) return fallback
    try {
      const stored = window.localStorage.getItem(STORAGE_PREFIX + key)
      return stored ? (JSON.parse(stored) as T) : fallback
    } catch {
      return fallback
    }
  })

  useEffect(() => {
    if (!isBrowser) return
    try {
      window.localStorage.setItem(STORAGE_PREFIX + key, JSON.stringify(value))
    } catch (e) {
      console.error(`[useLocalStorage] write failed for "${key}":`, e)
    }
  }, [key, value])

  return [value, setValue]
}
